"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import CommunityCurations from "@/components/community-curations/CommunityCurations";
import MyStreamWave from "../brain/my-stream/MyStreamWave";
import BrainContent from "../brain/content/BrainContent";
import useDeviceInfo from "../../hooks/useDeviceInfo";
import { useMyStreamOptional } from "@/contexts/wave/MyStreamContext";
const WavesView: React.FC = () => {
  const $ = _c(7);
  const myStream = useMyStreamOptional();
  const {
    isApp
  } = useDeviceInfo();
  const serialisedWaveId = myStream?.activeWave.id ?? null;
  const showPlaceholder = !serialisedWaveId && !isApp;
  let content = null;
  if (serialisedWaveId) {
    const t0 = `wave-${serialisedWaveId}`;
    let t1;
    if ($[0] !== serialisedWaveId || $[1] !== t0) {
      t1 = <MyStreamWave key={t0} waveId={serialisedWaveId} />;
      $[0] = serialisedWaveId;
      $[1] = t0;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    content = t1;
  } else {
    if (showPlaceholder) {
      let t0;
      if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = <CommunityCurations />;
        $[3] = t0;
      } else {
        t0 = $[3];
      }
      content = t0;
    }
  }
  const t0 = Boolean(serialisedWaveId);
  let t1;
  if ($[4] !== content || $[5] !== t0) {
    t1 = <BrainContent activeDrop={null} onCancelReplyQuote={_temp} showPinnedWaves={t0}>{content}</BrainContent>;
    $[4] = content;
    $[5] = t0;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};
export default React.memo(WavesView);
function _temp() {}